import RaindropButton, {
  ButtonStyle,
} from "../raindrop-button/raindrop-button.tsx";

// Deprecated - use RaindropButton instead
const SupportButton = ({
  isSupporting = true,
  isShowingPauseOption = true,
  isPrimary = false,
  onClick = () => {},
  onCancel = () => {},
}) => {
  if (!isSupporting) {
    return (
      <RaindropButton
        title="Give"
        style={isPrimary ? ButtonStyle.Primary : ButtonStyle.Outline}
        onClick={(e) => {
          onClick();
          e.stopPropagation();
          e.preventDefault();
        }}
      />
    );
  }

  if (!isShowingPauseOption) {
    return (
      <RaindropButton
        isHidingTitle={true}
        icon="fa-check"
        style={ButtonStyle.Icon}
        onClick={(e) => {
          onCancel();
          e.stopPropagation();
          e.preventDefault();
        }}
      />
    );
  }

  return (
    <RaindropButton
      title={"Pause Support"}
      onClick={(e) => {
        onCancel();
        e.stopPropagation();
        e.preventDefault();
      }}
    />
  );
};

export default SupportButton;
